import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RewardsItemsList } from 'views/common/components/UI/RewardsItemsList/RewardsItemsList';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .SPCustomGrid': {
    position: 'relative',
  },
  '& .SPBg': {
    position: 'relative',
    height: '100%',
    marginLeft: 'calc(((-100vw + 1232px) / 2))',
    [theme.breakpoints.down('xl')]: {
      marginLeft: theme.spacing(-3),
    },
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
    '& .SPBGImage': {
      height: '100%',
      minHeight: theme.spacing(90),
      backgroundSize: 'cover',
      backgroundPosition: '0 0',
      backgroundRepeat: 'no-repeat',
      [theme.breakpoints.up('xl')]: {
        backgroundPosition: '-120px 0',
        minHeight: theme.spacing(100),
      },
      backgroundImage: "url('/imgs/auth_bg.jpg')",
    },
  },

  '& .SPRegistrationAside': {
    position: 'absolute',
    top: 0,
    padding: theme.spacing(5, 2, 8, 0),
    [theme.breakpoints.down('lg')]: {
      position: 'relative',
      padding: theme.spacing(3),
      margin: theme.spacing(0, -3),
      backgroundColor: theme.palette.grey[50],
      color: theme.palette.common.black,
      '& .text': {
        color: theme.palette.common.black,
      },
    },
  },
  '& .SUVFormContainer': {
    [theme.breakpoints.up('lg')]: {
      maxWidth: theme.spacing(75),
    },
    '& .TabBar': {
      '& .MuiTab-root.Mui-selected': {
        color: theme.palette.common.black,
      },
      '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.common.black,
      },
    },
  },

  '& .SPBannerContainer': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  '& .SPBanner': {
    width: '100%',
    flex: 1,
    minHeight: theme.typography.pxToRem(558),
    '& img': {
      objectPosition: 'bottom',
    },
  },

  '& .SPBannerFooter': {
    position: 'relative',
    height: theme.typography.pxToRem(226),
    display: 'flex',
    alignItems: 'center',
  },
  '& .SPBannerFooterrBG': {
    width: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: -1,
  },
}));

export const StyledRewardsItemsList = styled(RewardsItemsList)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    '& .text': {
      color: `${theme.palette.common.fogWhite}!important`,
    },
    '& .RLILogo path:nth-of-type(1)': {
      fill: theme.palette.common.fogWhite,
    },
  },
}));

export default StyledBox;
